import { useSplitEnabled } from '@buffer-mono/features'

/**
 * Gates whether a channel that requires media to publish still accepts a
 * text-only draft or post. A kill switch for the relaxed requirement shipped
 * for Pinterest, TikTok, YouTube, and Facebook Reel/Story (Instagram has
 * always accepted text-only, independent of this flag). A progressive
 * rollout, not an experiment, hence no `geid-` prefix.
 */
export const RELAX_DRAFT_VALIDATION_FLAG = 'relax-draft-validation'

export function useRelaxDraftValidationEnabled(): boolean {
  const { isEnabled, isReady } = useSplitEnabled(RELAX_DRAFT_VALIDATION_FLAG)

  return isReady && isEnabled
}
